import { Module, VuexModule, Mutation } from "vuex-module-decorators";

@Module({
  namespaced: true,
  name: "PricingHistory"
})
export default class PricingHistory extends VuexModule {
  searchQuery = "";

  @Mutation
  updateSearchQuery(val: PricingHistory["searchQuery"]) {
    this.searchQuery = val;
  }
}
